
let singleton = null;
let singletonEnforcer = 'singletonEnforcer';

class CommonPowerbook {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot--construct singleton"
        }
    }

    static get instance() {
        if (!singleton) {
            singleton = new CommonPowerbook(singletonEnforcer);
        }
        return singleton;
    }

    init(_option){
        this.isMobileDe = (/(iPhone|iPod|iPad|Android|NC Noob)/i.test(navigator.userAgent));

        this.__env = location.href.match(/(rc\.|rc\-)/i)? location.href.match(/(rc\.|rc\-)/i)[1]: 'live';
        this.__env = (/opdev\./i.test(location.href))? 'opdev': this.__env;
        this.__env = (/local\.|localhost|ui-static\.|file:/i.test(location.href))? 'local': this.__env;

        /*
        let apiurls = {
            'local' : 'http://ui-static.korea.ncsoft.corp/powerbook/rwd/dummydata',
            'opdev' : 'http://opdev.api.lineage.plaync.com/api/powerbook/wiki',
            'rc'    : 'https://rc-apilineage.plaync.com/api/api/powerbook/wiki',
            'rc-'   : 'https://rc-apilineage.plaync.com/api/api/powerbook/wiki',
            'live'  : 'https://api.lineage.plaync.com/api/api/powerbook/wiki'
        };
        this.__apiUrl = apiurls[this.__env];

        let staticurls = {
            'local' : 'http://ui-static.korea.ncsoft.corp',
            'opdev' : 'http://ui-static.korea.ncsoft.corp',
            'rc'    : 'https://rc-wstatic.plaync.co.kr',
            'rc-'   : 'https://rc-wstatic.plaync.co.kr',
            'live'  : 'https://wstatic-cdn.plaync.com'
        };
        this.__staticHost = staticurls[this.__env];

        let powerbookURL = {
            'local' : 'http://opdev.lineage.plaync.com/powerbook',
            'opdev' : 'http://opdev.lineage.plaync.com/powerbook',
            'rc'    : 'https://rc-lineage.plaync.com/powerbook',
            'rc-'   : 'https://rc-lineage.plaync.com/powerbook',
            'live'  : 'https://lineage.plaync.com/powerbook'
        };
        this.__powerbookURL = powerbookURL[this.__env];
        */


        this.__apiUrl = _option.apiURL;
        this.__isIngame = !!_option.isIngame;
        this.__staticHost = _option.staticURL;
        this.__staticHostImg = _option.staticURLImg;
        this.__powerbookURL = '/powerbook/wiki';

    }

    apiUrl(_val){
        return this.__apiUrl + '/api/powerbook/wiki/' + _val;
    }

    get isMobile(){
        return this.isMobileDe;
    }

    get powerbookURL(){
        return this.__powerbookURL;
    }

    get staticURL(){
        return this.__staticHost;
    }

    get staticImgURL(){
        return this.__staticHostImg;
    }

    get isIngame(){
        return this.__isIngame;
    }

    get env(){
        return this.__env;
    }

    enchantMaker(_d){
        let str = '';
        switch (_d) {
            case '0':
                str = '0 → +1부터 실패할 가능성 있음';
                break;
            case '-1':
                str = '불가능';
                break;
            default:
                str = '+' + _d + '까지 안전하게 가능';
        }
        return str;
    }

    marketPriceLink(_id){
        let serverid = '';
        if(this.objHasKeys(window, ['userData', 'gameAccount', 'serverId']) && window.userData.gameAccount.serverId != ''){
            serverid = '&serverId=' + window.userData.gameAccount.serverId;
        }

        return '/world/item/detail?itemId=' + _id + serverid;
    }

    objHasKeys( obj={}, keys=[]) {
        let next = keys.shift();
        return obj[next] && (!keys.length || this.objHasKeys(obj[next], keys));
    }

    optionList(_d){
        if(!_d) return '-';
        let list = (Array.isArray(_d))? _d: _d.split(', ');

        let optionList = list.map( (item) =>{
            let arr = /([^뷁]+)([-|+][0-9]+)/g.exec(item);
            let strA = (!!arr && !!arr.length)? arr[1]: item;
            let strB = (!!arr && !!arr.length)? arr[2]: '';

            return `<a href="${this.__powerbookURL}/${strA}">${strA}</a>${strB}`;
        } ).join(', ');
        return optionList;
    }
    /**
     * 숫자 앞에 0 붙여주기 ex) '01', '001'
     * leadingZeros( 3, 2 ) // return '03'
     */
    leadingZeros(n, digits) {
        let zero = '';
        const len = n.toString().length;
        let i = 0;
        if (len < digits) {
            for (; i < digits - len; i += 1) {
                zero += '0';
            }
        }
        return zero + n;
    }


}

export default CommonPowerbook;


// WEBPACK FOOTER //
// ./common/CommonPowerbook.js